const pagesLicensesEn = {
  title: "Licenses",
  inventory: {
    pageTitle: "License Inventory",
    filterPlaceholder: "Filter by name",
    addLicense: "Add License",
    tabs: {
      active: "Active",
      awaiting: "Awaiting",
      expired: "Expired",
      all: "All",
      installed: "Installed",
      mwOs: "MW & OS",
      scratch: "Scratch",
      product: "Product",
      saas: "SaaS",
      customSaas: "Custom SaaS",
    },
    actions: {
      openMenu: "Open menu",
      delete: "Delete license",
    },
    deleteLicenseDialog: {
      title: "Delete License",
      description: "Delete the following license.",
      warning: "This action cannot be undone.",
      successToast: "License deleted successfully",
      cancelButton: "Cancel",
      deleteButton: "Delete",
    },
  },
  add: {
    pageTitle: "Add License",
    intro: {
      header: {
        title: "Add License",
      },
      body: {
        onPremises: {
          title: "On-Premises",
          description: "On-Premises",
        },
        itemCard: {
          requiredDetails: "Required Details",
          licenseName: "License Name",
          totalQuantity: "Total quantity",
        },
        selectLicenseType: "Select licensing software types:",
        fillOutDetails: "Fill out details",
      },
      options: {
        description: "Or you might want to...",
        bulkCsvUpload: {
          description: "Bulk upload licenses from a CSV file",
          title: "Bulk CSV Upload",
          button: "Bulk CSV Upload",
          selectedLicenseType: "Selected license type",
        },
        syncIT: "Sync with external service",
      },
    },
    form: {
      navigation: {
        onPremises: {
          title: "On-Premises",
        },
        step: {
          one: "General Identification",
          two: "License contract details",
          three: "Key & Activation",
          four: "License scope & usage",
        },
        completed: {
          result: "Result",
          message: "License added.",
          completedBy: "Completed by:",
          goToLicense: "Go to license",
          continueAdding: "Continue adding another license",
        },
      },
      step1: {
        title: "General Identification",
        licensingSoftware: {
          title: "Licensing Software",
          name: {
            label: "License Name",
            placeholder: "Enter license name",
          },
          vendorName: {
            label: "Vendor",
            placeholder: "Enter vendor name",
          },
        },
        secondCard: {
          productVersion: {
            label: "Product version",
            placeholder: "2012 R2, 10.0.17763, ...",
          },
          edition: {
            label: "Edition / SKU",
            placeholder: "Standard, Datacenter, ...",
          },
          platform: {
            label: "Platform",
            placeholder: "Windows, macOS, Linux, ...",
          },
        },
        next: "License Contract Details",
        nextMustOnlyMode: "License Scope & Usage",
      },
      step2: {
        title: "License Contract Details",
        firstCard: {
          licenseType: {
            label: "License type",
            placeholder: "Select license type",
          },
          purchaseChannel: {
            label: "Purchase channel",
            placeholder: "Enter purchase channel",
          },
          supportContract: {
            label: "Support contract",
            placeholder: "Enter support contract",
          },
        },
        secondCard: {
          purchaseDate: {
            label: "Purchase/Agreement date",
            placeholder: "Select purchase/agreement date",
          },
          startDate: {
            label: "License start date",
            placeholder: "Select license start date",
          },
          expirationDate: {
            label: "License expiration date",
            placeholder: "Select license expiration date",
          },
          renewalDate: {
            label: "License renewal date",
            placeholder: "Select license renewal date",
          },
        },
        next: "Key & Activation",
        nextMustOnlyMode: "License Scope & Usage",
      },
      step3: {
        title: "Key & Activation",
        firstCard: {
          activationMethod: {
            label: "Activation method",
            placeholder: "Select activation method",
            options: {
              AUTOMATIC: "Automatic",
              MANUAL: "Manual",
              SERVER_BASED: "Server-based",
            },
          },
          activationStatus: {
            label: "Activation status",
            placeholder: "Select activation status",
            options: {
              ACTIVE: "Active",
              FAILED: "Failed",
              REVOKED: "Revoked",
              PENDING: "Pending",
              EXPIRED: "Expired",
            },
          },
          licenseKey: {
            label: "License key",
            placeholder: "Enter license key",
          },
          licensingServer: {
            label: "Licensing server info",
            placeholder: "Enter licensing server info",
          },
          managementTool: {
            label: "Management tool",
            placeholder: "Enter management tool",
          },
        },
        next: "License Scope & Usage",
        nextMustOnlyMode: "License Scope & Usage",
      },
      step4: {
        title: "License Scope & Usage",
        firstCard: {
          totalQuantity: {
            label: "Total license quantity",
            placeholder: "Enter total quantity",
          },
          licenseMetric: {
            label: "License metric",
            placeholder: "Select license metric",
          },
          allocationType: {
            label: "Allocation type",
            placeholder: "Select allocation type",
            options: {
              userBased: "User-based",
              deviceBased: "Device-based",
              concurrentBased: "Concurrent-based",
            },
          },
        },
        submit: "Submit",
      },
      progressbar: {
        total: "Total",
        mustItem: "Must Item",
        left: "{{value}}left",
        filled: "filled",
        modeSetting: "Mode Settings",
        mustItemOnly: "Must item only",
      },
    },
  },
  columns: {
    license: {
      noSuiteName: "No suite name",
    },
  },
  detail: {
    header: {
      assigned: "Assigned/Total",
      status: "Status",
      renewalDate: "Renewal date",
      noRenewalDate: "No renewal date",
    },
    sections: {
      generalIdentification: "General Identification",
      licenseContractDetails: "License Contract Details",
      keyActivation: "Key & Activation",
      licenseScopeUsage: "License Scope & Usage",
      complianceAudit: "Compliance & Audit",
      auxiliaryFields: "Auxiliary Fields",
    },
    generalIdentification: {
      title: "General Identification",
      name: "License name",
      softwareName: "Software name",
      licenseCategory: "License Category",
      productVersion: "Product Version",
      editionSku: "Edition / SKU",
      vendor: "Vendor",
      platform: "Platform",
      licenseCategoryOptions: {
        onPremise: "On-Premise",
        cloud: "Cloud",
      },
    },
    contractDetails: {
      title: "License Contract Details",
      purchaseAgreementDate: "Purchase/Agreement date",
      startDate: "License start date",
      expirationDate: "License expiration date",
      licenseType: "License type",
      renewalDate: "Renewal date",
      purchaseChannel: "Purchase channel",
      supportContract: "Support/Maintenance contact",
      licenseTypeOptions: {
        annual: "Annual",
        monthly: "Monthly",
        perpetual: "Perpetual",
        manual: "Manual",
      },
    },
    keyActivation: {
      title: "Key Activation",
      licenseKey: "License key",
      activationStatus: "Activation status",
      activationMethod: "Activation method",
      licensingServerInfo: "Licensing server info",
      managementToolInfo: "Management tool info",
      activationMethodOptions: {
        AUTOMATIC: "Automatic",
        MANUAL: "Manual",
        SERVER_BASED: "Server-based",
      },
      activationStatusOptions: {
        ACTIVE: "Active",
        FAILED: "Failed",
        REVOKED: "Revoked",
        PENDING: "Pending",
        EXPIRED: "Expired",
      },
    },
    scopeUsage: {
      title: "Scope Usage",
      totalQuantity: "Total quantity",
      availableQuantity: "Available quantity",
      usedQuantity: "Used quantity",
      licenseMetric: "License metric",
      licenseMetricOptions: {
        userBased: "User-based",
        deviceBased: "Device-based",
        concurrentBased: "Concurrent-based",
      },
    },
    statusBadge: {
      active: "Active",
      expired: "Expired",
      failed: "Failed",
      pending: "Pending",
      revoked: "Revoked",
      inactive: "Inactive",
      all: "All",
    },
    toast: {
      licenseUpdatedTitle: "License updated",
      licenseUpdated: "License updated successfully",
    },
  },
  detailDevices: {
    pageTitle: "License Devices",
    tabs: {
      assigned: "Assigned",
    },
    assignButton: "Assign License",
    deviceAssignmentDialog: {
      title: "Assign Device",
      devicesLabel: "Devices",
      deviceSearchPlaceholder: "Search devices",
      assignButtonLabel: "Assign",
      cancelButtonLabel: "Cancel",
      note: "Note",
      assignmentError: "Failed to assign device",
    },
  },
  devices: {
    unassign: "Unassign",
    unassignDialog: {
      description:
        'Are you sure you want to unassign "{{deviceName}}" from this license?',
      successToast: "Device unassigned successfully",
    },
  },
  detailPeople: {
    pageTitle: "License People",
    tabs: {
      assigned: "Assigned",
    },
    assignButton: "Assign License",
    deviceAssignmentDialog: {
      title: "Assign Device",
      devicesLabel: "Devices",
      deviceSearchPlaceholder: "Search devices",
      assignButtonLabel: "Assign",
      cancelButtonLabel: "Cancel",
      note: "Note",
    },
  },
  common: {
    copiedToClipboard: "Copied to clipboard!",
    renewalCycle: {
      ANNUAL: "Annual",
      MONTHLY: "Monthly",
      PERPETUAL: "Perpetual",
      MANUAL: "Manual",
    },
  },
};

export default pagesLicensesEn;
